import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import gql from 'graphql-tag'
import styled from 'styled-components'
import { TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment } from 'generated/graphql'
import { ExamContext } from '@app.feature/exam/context/ExamContext'
import { ANSWER_NUMVER_MAP } from '@app.feature/exam/gsat2024-2/constants/answerNumberMap'
import { TentativeScoringQuestionContext } from '@app.feature/exam/gsat2024-2/context/TentativeScoringQuestionContext'
import { TentativeScoringQuestionListFormType } from '../../../../../types/tentativeScoringQuestionListForm.type'
import AnswerRadioButtonGroup from '../components/radio/AnswerRadioButtonGroup'

interface TentativeScoringQuestionItemDesktopProps {
  questionData: TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment
}

gql`
  fragment TentativeScoringQuestionItemDesktop_examGradingQuestion on ExamGradingQuestion {
    id
    answers
    content
    seq
    statistics {
      answer
      rate
    }
    subject
    userAnswers
  }
`

const TentativeScoringQuestionItemDesktop = ({
  questionData,
}: TentativeScoringQuestionItemDesktopProps) => {
  const { handleCheckReservation } = useContext(ExamContext)
  const { subject } = useContext(TentativeScoringQuestionContext)
  const { setValue, register, resetField } =
    useFormContext<TentativeScoringQuestionListFormType>()

  const predictionAnswer = ANSWER_NUMVER_MAP[questionData.answers[0] - 1]

  const handleChangeAnswer = () => {
    handleCheckReservation({
      onReservated: () => {
        setValue(
          `${subject}.inputQuestions.${questionData.seq - 1}.questionId`,
          questionData.id,
        )
      },
      onNotReservated: () => {
        resetField(`${subject}.inputQuestions.${questionData.seq - 1}`)
      },
    })
  }

  return (
    <StyledWrapper>
      <p className="question-number">{questionData.seq}번 문항</p>
      <p className="question-content">{questionData.content}</p>
      <p className="prediction-answer-text">가답안 {predictionAnswer}번</p>
      <p className="selected-answer-text">내가 고른답</p>
      <AnswerRadioButtonGroup
        id={`tentative-scoring-${subject}-question-${questionData.seq}`}
        {...register(
          `${subject}.inputQuestions.${questionData.seq - 1}.selectedAnswer`,
          {
            onChange: handleChangeAnswer,
          },
        )}
      />
    </StyledWrapper>
  )
}

export default TentativeScoringQuestionItemDesktop

const StyledWrapper = styled.li`
  width: 100%;
  min-height: 62px;
  display: flex;
  align-items: center;
  border-top: 1px solid #eeeeee;
  padding-right: 20px;

  &:first-child {
    border-top: 0;
  }

  p {
    flex-shrink: 0;
  }

  > .question-number {
    width: 102px;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: -0.64px;
    color: #333;
    text-align: center;
  }
  > .question-content {
    width: 290px;
    padding-left: 20px;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: -0.64px;
    text-align: left;
    color: #333;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
  }

  > .prediction-answer-text {
    width: 115px;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: -0.64px;
    text-align: center;
    color: #333;
  }

  > .selected-answer-text {
    width: 111px;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: -0.64px;
    text-align: center;
    color: #333;
  }
`
